import React, { useState, useEffect } from "react";

import Image1 from "../../assets/new-images/svg_logo.svg";

import Offcanvas from "react-bootstrap/Offcanvas";

import { NavLink, Link } from "react-router-dom";

import { api } from "../Constants";

import axios from "axios";

import { useDispatch, useSelector } from "react-redux";

import { fetchCartitemslice } from "../../features/cartItemSlice";

import { useNavigate } from "react-router-dom";



function Header() {

  const [categorylist, setCategorylist] = useState([]);

  const [stickyClass, setStickyClass] = useState("");

  const [show, setShow] = useState(false);

  const [menuOpenone, setMenuOpen] = useState(false);

  const [isSubMenuVisible, setIsSubMenuVisible] = useState(false);

  const [userDropdown, setUserDropdown] = useState(false);

  const [userDropdownMobile, setUserDropdownMobile] = useState(false);

  const navigate = useNavigate();

  const username = localStorage.getItem("username");

  const email = localStorage.getItem("email");

  const phone = localStorage.getItem("phone");

  const userid = localStorage.getItem("userid");



  useEffect(() => {

    axios

      .post(api + "category_list", {

        dealer_id: userid,

      })

      .then((response) => {

        setCategorylist(response.data.data);

      })

      .catch((error) => {

        console.error("Error:", error);

      });

  }, []);



  useEffect(() => {

    window.addEventListener("scroll", stickNavbar);

    return () => window.removeEventListener("scroll", stickNavbar);

  }, []);



  const stickNavbar = () => {

    if (window !== undefined) {

      let windowHeight = window.scrollY;

      windowHeight > 70

        ? setStickyClass("sticky is-sticky")

        : setStickyClass("");

    }

  };



  const handleClose = () => setShow(false);

  const handleShow = () => setShow(true);



  const Mobilemenu = () => {

    setMenuOpen(!menuOpenone);

  };



  const toggleSubMenu = () => {

    setIsSubMenuVisible(!isSubMenuVisible);

  };



  const toggleUserDropdownMobile = () => {

    setUserDropdownMobile(!userDropdownMobile);

  };



  const handleLogout = () => {

    localStorage.removeItem("username");

    localStorage.removeItem("email");

    localStorage.removeItem("phone");

    localStorage.removeItem("userid");

    navigate("/");

    window.location.reload();

  };



  const cartItems = useSelector((state) => state.cartListslice.cartItems || []);

  const [cartItemsss, setCartItems] = useState(cartItems);



  useEffect(() => {

    setCartItems(cartItems.map((item) => ({ ...item })));

  }, [cartItems]);



  const dispatch = useDispatch();



  useEffect(() => {

    if (userid) {

      dispatch(fetchCartitemslice({ userids: userid }));

    }

  }, [dispatch, userid]);



  return (

    <div>

      <header className="header-area header-wide">

        {/* Desktop Header */}

        <div className="main-header d-none d-lg-block">

          <div className={`header-main-area ${stickyClass}`}>

            <div className="container">

              <div className="row align-items-center position-relative">

                <div className="col-lg-3">

                  <div className="logo">

                    <NavLink to="/">

                      <img src={Image1} alt="Brand-Logo" />

                    </NavLink>

                  </div>

                </div>

                <div className="col-lg-6 position-static">

                  <div className="main-menu-area">

                    <div className="main-menu">

                      <nav className="desktop-menu">

                        <ul>

                          <li>

                            <Link to="/">Home</Link>

                          </li>

                          <li>

                            <Link to="/About-Us">About Us</Link>

                          </li>

                          <li>

                            <Link to={`/category`}>

                              Collections <i className="fa fa-angle-down"></i>

                            </Link>

                            <ul className="dropdown">

                              <li>

                                <Link to={`/category`}>All Products</Link>

                              </li>

                              {categorylist.map((ca) => (

                                <li key={ca.category_id}>

                                  <Link to={`/category/${ca.category_slug}`}>

                                    {ca.name}

                                  </Link>

                                </li>

                              ))}

                            </ul>

                          </li>

                          <li>

                            <Link to="/contact-us">Contact us</Link>

                          </li>

                        </ul>

                      </nav>

                    </div>

                  </div>

                </div>

                <div className="col-lg-3">

                  <div className="header-right d-flex align-items-center justify-content-lg-end">

                    <div className="header-configure-area">

                      <div className="header-top-settings header-top-socialicon">

                        <ul className="nav align-items-center justify-content-end">

                          <li

                            className="curreny-wrap"

                            onMouseEnter={() => setUserDropdown(true)}

                            onMouseLeave={() => setUserDropdown(false)}

                            style={{

                              position: "relative",

                              color: "#bc1823",

                              paddingTop: "5px",

                            }}

                          >

                            <i className="fa fa-user"></i> &nbsp;

                            <span>

                              {userid

                                ? username.length > 10

                                  ? username.slice(0, 10) + ".."

                                  : username

                                : null}

                            </span>

                            {userDropdown && (

                              <div

                                className="user-dropdown"

                                style={{

                                  position: "absolute",

                                  width: "150px",

                                  top: "100%",

                                  right: "-50px",

                                  background: "#fff",

                                  boxShadow: "0 2px 8px rgba(0,0,0,0.15)",

                                  zIndex: 1000,

                                  padding: "10px",

                                }}

                              >

                                {userid ? (

                                  <>

                                    <NavLink

                                      to="/my-profile"

                                      style={{

                                        display: "block",

                                        padding: "5px 10px",

                                        fontSize: "16px",

                                      }}

                                    >

                                      My Profile

                                    </NavLink>

                                    <NavLink

                                      onClick={handleLogout}

                                      style={{

                                        display: "block",

                                        padding: "5px 10px",

                                        fontSize: "16px",

                                      }}

                                    >

                                      Logout

                                    </NavLink>

                                  </>

                                ) : (

                                  <NavLink

                                    to="/login"

                                    style={{

                                      display: "block",

                                      padding: "5px 10px",

                                      fontSize: "16px",

                                    }}

                                  >

                                    Login

                                  </NavLink>

                                )}

                              </div>

                            )}

                          </li>

                          {userid && (

                            <li

                              className="curreny-wrap"

                              style={{ position: "relative" }}

                            >

                              <Link to="/cart" className="cart_icon">

                                {cartItems.length > 0 && (

                                  <span className="badge_icon">

                                    {cartItems.length}

                                  </span>

                                )}

                                <i className="fa fa-shopping-cart"></i>

                              </Link>

                            </li>

                          )}

                          <li className="curreny-wrap">

                            <a

                              href="https://www.facebook.com/arthikajewel"

                              target="_blank"

                              rel="noreferrer"

                            >

                              <i className="fa fa-facebook"></i>

                            </a>

                          </li>

                          <li className="curreny-wrap">

                            <a

                              href="https://www.instagram.com/arthikajewels/"

                              target="_blank"

                              rel="noreferrer"

                            >

                              <i className="fa fa-instagram"></i>

                            </a>

                          </li>

                        </ul>

                      </div>

                    </div>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>



        {/* Mobile Header */}

        <div className={`mobile-header d-lg-none d-md-block ${stickyClass}`}>

          <div className="container-fluid">

            <div className="row align-items-center">

              <div className="col-12">

                <div className="mobile-main-header">

                  <div className="mobile-logo">

                    <Link to="/">

                      <img src={Image1} alt="Brand Logo" />

                    </Link>

                  </div>

                  <div style={{ display: "flex", gap: "11px" }}>

                    <div className="mobile_login_user">

                      <span>

                        {userid

                          ? username.length > 10

                            ? username.slice(0, 10) + ".."

                            : username

                          : null}

                      </span>

                    </div>



                    {/* ✅ Show Cart on Mobile Only If Logged In */}

                    {userid && (

                      <div className="mobile_cart_box">

                        <Link

                          to="/cart"

                          className="cart_icon"

                          style={{ position: "relative" }}

                        >

                          {cartItemsss.length > 0 && (

                            <span className="badge_icon">

                              {cartItemsss.length}

                            </span>

                          )}

                          <i

                            className="fa fa-shopping-cart"

                            style={{ color: "#bc1823" }}

                          ></i>

                        </Link>

                      </div>

                    )}



                    <div className="mobile-menu-toggler">

                      <button onClick={handleShow} className="mobile-menu-btn">

                        <span></span>

                        <span></span>

                        <span></span>

                      </button>

                    </div>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>



        {/* Offcanvas Menu for Mobile */}

        <Offcanvas show={show} onHide={handleClose}>

          <Offcanvas.Header closeButton>

            <Offcanvas.Title>

              <img src={Image1} alt="logo" />

            </Offcanvas.Title>

          </Offcanvas.Header>

          <Offcanvas.Body>

            <div className="mobile-navigation">

              <nav>

                <ul className="mobile-menu">

                  <li>

                    <Link onClick={handleClose} to="/">

                      Home

                    </Link>

                  </li>

                  <li>

                    <Link onClick={handleClose} to="/About-Us">

                      About Us

                    </Link>

                  </li>

                  <li className="menu-item-has-children">

                    <span onClick={toggleSubMenu} className="menu-expand">

                      <i></i>

                    </span>

                    <Link to={`/category`}>Collections</Link>

                    {isSubMenuVisible && (

                      <ul className="dropdown">

                        <li>

                          <Link to={`/category`}>All Products</Link>

                        </li>

                        {categorylist.map((ca) => (

                          <li key={ca.category_slug}>

                            <Link

                              to={`/category/${ca.category_slug}`}

                              onClick={handleClose}

                            >

                              {ca.name}

                            </Link>

                          </li>

                        ))}

                      </ul>

                    )}

                  </li>

                  <li>

                    <Link onClick={handleClose} to="/contact-us">

                      Contact us

                    </Link>

                  </li>



                  {/* ✅ Mobile Login/Logout */}

                  {userid ? (

                    <>

                      <li>

                        <Link onClick={handleClose} to="/my-profile">

                          My Profile

                        </Link>

                      </li>

                      <li>

                        <Link

                          onClick={() => {

                            handleLogout();

                            handleClose();

                          }}

                        >

                          Logout

                        </Link>

                      </li>

                    </>

                  ) : (

                    <li>

                      <Link onClick={handleClose} to="/login">

                        Login

                      </Link>

                    </li>

                  )}

                </ul>

              </nav>

            </div>

          </Offcanvas.Body>

        </Offcanvas>

      </header>

    </div>

  );

}



export default Header;

